import { Modal, type ModalFuncProps, type ModalProps } from "antd"
import React from "react"

export const MODAL_CONFIRM_CONFIG = {
  formChanged: {
    title: "Are you sure you want to leave?",
    content: "You have unsaved changes. If you leave, they will be lost.",
    okText: "Leave",
    cancelText: "Stay",
    centered: true
  },
  cancelChanges: {
    title: "Confirm canceling",
    content:
      "Are you sure you want to cancel changes? This action can NOT be undone.",
    okText: "Confirm",
    cancelText: "Back",
    centered: true,
    okButtonProps: { danger: true, ghost: true }
  }
} as const satisfies Record<string, Omit<ModalFuncProps, "onOk" | "onCancel">>

interface FormChangedConfirmProps extends ModalProps {
  configKey?: keyof typeof MODAL_CONFIRM_CONFIG
  content?: React.ReactNode
}

export function FormChangedConfirm({
  configKey = "formChanged",
  title,
  content,
  okText,
  cancelText,
  ...props
}: FormChangedConfirmProps) {
  const config = MODAL_CONFIRM_CONFIG[configKey]

  return (
    <Modal
      title={title ?? config.title}
      okText={okText ?? config.okText}
      cancelText={cancelText ?? config.cancelText}
      {...props}
    >
      {typeof content === "string" ? (
        <p>{content}</p>
      ) : content ? (
        content
      ) : (
        <p>{config.content}</p>
      )}
    </Modal>
  )
}
